import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { AutoComplete, Spin } from 'antd'
import { debounce, isEmpty, isNil } from 'lodash'
import http from '../../../utils/api'

const AutocompleteField = ({
  id = null,
  name,
  value,
  className,
  url,
  filterBy,
  method = 'get',
  transform,
  onFocus,
  onBlur,
  onChange,
}) => {
  const [fetching, setFetching] = useState(false)
  const [options, setOptions] = useState([])
  const [selectedValue, setSelectedValue] = useState(value)
  const [validOptions, setValidOptions] = useState([])
  const handleSearch = useCallback(
    (val) => {
      setFetching(true)

      const key = method === 'get' ? 'params' : 'data'

      const filterRequestData =
        isNil(filterBy) || isEmpty(filterBy) ? {} : filterBy
      const requestData = { [key]: { q: val, ...filterRequestData } }

      http[method](url, requestData)
        .then((response) => {
          const result = response.data
          console.log('response', result)
          setOptions(isNil(transform) ? result : transform(result))
          if (!isEmpty(result)) {
            setValidOptions(isNil(transform) ? result : transform(result))
          }
        })
        .finally(() => {
          setFetching(false)
        })
    },
    [url, method, filterBy, transform]
  )

  const handleBlur = () => {
    // const e = { persist: () => {}, name };
    if (selectedValue !== '') {
      if (!isEmpty(validOptions)) {
        onChange(validOptions[0].value)
      }
    }
    onBlur(name)
  }

  const handleChange = useCallback(
    (val) => {
      setOptions([])
      setSelectedValue(val)
      onChange(val)
    },
    [onChange]
  )

  return (
    <AutoComplete
      id={isNil(id) ? name : id}
      name={name}
      className={className}
      value={value}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      dataSource={options}
      onBlur={handleBlur}
      onFocus={onFocus}
      onChange={handleChange}
      onSearch={handleSearch}
    />
  )
}

AutocompleteField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  method: PropTypes.oneOf(['get', 'post']),
  filterBy: PropTypes.object,
  transform: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
}

export default AutocompleteField
